<template>
  <div>
    <el-row
      v-for="(item, index) in zdFormattedValue"
      :key="index"
      class="row"
    >
      <el-col :span="2" :offset="1" class="column_title">
        <label :class="index === 0 ? '' : 'white-lable'">
          {{ labelText(zdItem.label) }}
        </label>
      </el-col>
      <el-col :span="3">
        <el-input
          :disabled="setupDisable() || getAuthShow()"
          :placeholder="$t('view.placeholder')"
          :value="item.fields"
          @input="updateItemField(index, 'fields', $event)"
          :class="{ 'question-mark-highlight': hasQuestionMarkInField(item.fields) }"
        ></el-input>
      </el-col>
      <el-col :span="5">
        <el-input
          :disabled="setupDisable() || getAuthShow()"
          :placeholder="$t('view.placeholder')"
          :value="item.specification"
          @input="updateItemField(index, 'specification', $event)"
          :class="{ 'question-mark-highlight': hasQuestionMarkInField(item.specification) }"
        ></el-input>
      </el-col>
      <el-col :span="2" :offset="2" class="column_title">
        <label :class="index === 0 ? '' : 'white-lable'">
          {{ labelText(zdItem.label) }}
        </label>
      </el-col>
      <el-col :span="3">
        <el-input
          :disabled="setupDisable() || getAuthShow()"
          :placeholder="$t('view.placeholder')"
          :value="item.fields"
          @input="updateItemField(index, 'fields', $event)"
          :class="{ 'question-mark-highlight': hasQuestionMarkInField(item.fields) }"
        ></el-input>
      </el-col>
      <el-col :span="4">
        <el-input
          :disabled="setupDisable() || getAuthShow()"
          :placeholder="$t('view.placeholder')"
          :value="item.test_method"
          @input="updateItemField(index, 'test_method', $event)"
          :class="{ 'question-mark-highlight': hasQuestionMarkInField(item.test_method) }"
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button
          type="primary"
          icon="el-icon-circle-plus"
          circle
          :disabled="setupDisable() || getAuthShow()"
          @click="addClick"
        ></el-button>
        <el-button
          type="danger"
          :disabled="setupDisable() || getAuthShow()"
          icon="el-icon-delete"
          circle
          @click="removeClick(index)"
        ></el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";

export default {
  name: "ZDTwoColumnCustomInput",
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      const cache = {};
      return (label) => {
        if (cache[label]) return cache[label];
        const key = "content." + label.toLowerCase().replaceAll(" ", "_");
        cache[label] = this.$t(key);
        return cache[label];
      };
    },
    zdFormattedValue: {
      get() {
        if (!Array.isArray(this.zdItem.value) || this.zdItem.value.length === 0) {
          return [{
            fields: "",
            specification: "",
            test_method: ""
          }];
        }
        return this.zdItem.value;
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        });
      },
    },
  },
  created() {
    if (!Array.isArray(this.zdItem.value) || this.zdItem.value.length === 0) {
      this.initValue();
    }
    
    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },
  methods: {
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload);
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    // 更新指定索引和字段的值
    updateItemField(index, field, value) {
      const newValue = [...this.zdFormattedValue];
      newValue[index] = {
        ...newValue[index],
        [field]: value
      };
      this.zdFormattedValue = newValue;
    },
    initValue() {
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: [{
          fields: "",
          specification: "",
          test_method: ""
        }]
      });
    },
    addClick() {
      this.zdFormattedValue = [...this.zdFormattedValue, {
        fields: "",
        specification: "",
        test_method: ""
      }];
    },
    removeClick(index) {
      if (this.zdFormattedValue.length > 1) {
        this.zdFormattedValue = this.zdFormattedValue.filter((_, i) => i !== index);
      }
    },
    // 检测单个字段是否包含问号
    hasQuestionMarkInField(fieldValue) {
      if (!fieldValue) return false;
      return fieldValue.includes('?') || fieldValue.includes('？');
    },
    
    /**
     * 设置组件是否禁用
     */
    setupDisable() {
      const pageStatus = this.pageStatus;
      
      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }
      
      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    },
    
    /**
     * 处理页面状态变化
     */
    handlePageStatusChange() {
      // console.info("ZDTwoColumnCustomInput: Page status changed to", pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    /**
     * 处理标签页变化
     */
    handleTabChanged() {
      // console.info("ZDTwoColumnCustomInput: Tab changed to", data.tabName, "with status", data.pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    }
  },
};
</script>

<style scoped>
.row {
  margin-bottom: 10px;
}
.white-lable {
  color: white;
}
.column_title {
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 36px;
}
</style>
<style src="./input-highlight.css" scoped>

</style>